import React from 'react';
const items = [{
  title: 'Word-for-Word Direction',
  body: '348 lines written to be said out loud. Say them as written your first Saturday; by your third they sound like you.'
}, {
  title: 'The 12-Minute Formals Method',
  body: 'A smallest-to-largest calling order, called by name, placed by height. Formals done before cocktail hour is.'
}, {
  title: 'Break Points',
  body: 'A table for every part of the day: +15, +30, +45, +60 minutes → what it eats, what you lose for good, and what to cut first.'
}, {
  title: 'The 8-Minute Version',
  body: 'Every part of the day has one. When the schedule collapses, you don’t improvise the cut. You run it.'
}];
export function Differentiators() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-122" data-mp="1ddtin2hygnbq">
      <div className="mx-auto max-w-5xl px-5" data-id="element-123" data-mp="2jtdpi4y7qtmu">
        <h2 className="text-center font-serif text-3xl sm:text-4xl text-ink" data-id="element-124" data-mp="2juota4rns1dy">
          The four things no posing guide has
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-125" data-mp="bpc8p7xlnzij" />

        <ol className="mt-12 grid gap-x-12 gap-y-10 sm:grid-cols-2" data-id="element-126" data-mp="7n8wui70qswq">
          {items.map((item, index) => <li key={item.title} className="flex gap-5" data-id="element-127" data-mp="2nvyb06sbxeb" data-mpi={index}>
              <span className="font-serif text-3xl leading-none text-gold" aria-hidden="true" data-id="element-128" data-mp="2mb4jcsaoihi">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div data-id="element-129" data-mp="3owe06n8wt4ev">
                <h3 className="font-serif text-xl text-ink" data-id="element-130" data-mp="3owx615lac2cj">{item.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-131" data-mp="3k3kvfzdfxw2s">
                  {item.body}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}